import { apiCall } from "./firebase";

export interface MaintenanceStatus {
  enabled: boolean;
  environment: string;
  message: string;
  timestamp: string;
  estimatedEndTime?: string;
}

class MaintenanceService {
  private readonly MAINTENANCE_DOC_PATH = "system/maintenance";

  /**
   * Check if maintenance mode is enabled for the current environment
   */
  async isMaintenanceModeEnabled(): Promise<MaintenanceStatus | null> {
    try {
      const response = await this.getMaintenanceStatus();
      return response?.enabled ? response : null;
    } catch (error) {
      console.error("Error checking maintenance mode:", error);
      return null;
    }
  }

  /**
   * Get current maintenance status
   */
  async getMaintenanceStatus(): Promise<MaintenanceStatus | null> {
    try {
      const response = await apiCall("/getMaintenanceStatus", {
        method: "POST",
        body: JSON.stringify({}),
      });
      return response;
    } catch (error) {
      console.error("Error getting maintenance status:", error);
      return null;
    }
  }
}

export const maintenanceService = new MaintenanceService();
